import { Model } from "@/models/base/model";

export default class MyGraph extends Model {
  private baseUrl = "/cms/api/my-report/graph"; // ベースURL
  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
  }

  // 期間内のデータを取得
  async getData(startDate: string, endDate: string): Promise<any> {
    this.url = `${this.baseUrl}?startDate=${startDate}&endDate=${endDate}`;
    return await super.fetch();
  }

  // 初回説明非表示設定
  async setChartHiddenFlag(): Promise<any> {
    this.url = `${this.baseUrl}/set-chart-hidden-flag`;
    return await this.save({}, "PATCH");
  }
}
